import { i18next } from '@main/i18next';

export { i18next };
